export const DEFAULT_BOOTSTRAP_DATA = {
    requestId: null,
    access_token: null,
    dob_max_limit: null,
    dob_token_expiry: null,
    message_expiry_time: null,
    auth_expiry_time: null,
    max_dob_attempt_exceeded: null,
    resend_otp_interval: null,
    resend_otp_max_limit: null,
    refresh_call_status_interval: null,
    wma_settings: {
        wma_submit: true,
        wma_after_hours_allowed: false,
        wma_office_hours_allowed: false,
    },
    office_hours: [],
    application_type: null,
    // call_details
    phoneNumber: null,
    call_detail: {},
    // partner details
    partner: {
        id: null,
        name: null,
        office_phone_number: null,
        partner_short_id: null,
        wma_display_name: null,
        wma_enabled: null,
        timezone: 'America/Los_Angeles',
    },
    // heading
    headingDefaultHeading: null,
    headingDefaultWelcomeMessage: null,
    headingDefault911Str: null,
    // footer
    footerCopyright: null,
    footerTOS: null,
    // template
    template: {
        content: {
            // style
            textColor: '#313131',
            backgroundColor: '#4383C4',
            fontFamily: '"Roboto", sans-serif',
            // language
            en: {},
            es: {},
        },
    },
};

export const DEFAULT_REPLIES_DATA = {
    isExpired: false,
    responses: [],
};

export const DEFAULT_PROVIDERS_DATA = [];

export const FILTER_NON_URGENT_OPTIONS = false;

// Time constants in milliseconds
export const ONE_HOUR_MS = 60 * 60;
export const ONE_DAY_MS = 24 * ONE_HOUR_MS;
export const COOKIE_EXPIRY_TIME = ONE_HOUR_MS; // 30 * ONE_DAY_MS

export const modifyUserData = (items, setUserData) => {
    const temp = {};

    items.forEach(item => {
        const keyMapping = {
            style: {
                textColor: 'styleTextcolor',
                backgroundColor: 'styleBackgroundColor',
                fontFamily: 'styleFontFamily',
            },
            heading: {
                defaultHeading: 'headingDefaultHeading',
                defaultWelcomeMessage: 'headingDefaultWelcomeMessage',
                headingDefault911Str: 'headingDefault911Str',
            },
            footer: {
                copyright: 'footerCopyright',
                TOS: 'footerTOS',
            },
        };

        const mappings = keyMapping[item.type] || {};

        (item?.items || []).forEach(prop => {
            if (prop.value && mappings[prop.key]) {
                temp[mappings[prop.key]] = prop.value;
            }
        });
    });

    setUserData(temp);
};
